<template>
  <head>
    <meta charset="utf-8" />
    <title>Desk Birdy | Business Permits</title>
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <meta content="Rental management system by Nouveta LTD" name="description" />
    <meta content="Kelvin Njuguna" name="author" />
    <link rel="shortcut icon" href="assets/images/favicon.svg">
    <link href="assets/libs/dropzone/min/dropzone.min.css" rel="stylesheet" type="text/css" />
    <link href="assets/libs/datatables.net-bs4/css/dataTables.bootstrap4.min.css" rel="stylesheet" type="text/css" />
    <link href="assets/libs/datatables.net-buttons-bs4/css/buttons.bootstrap4.min.css" rel="stylesheet" type="text/css" />
    <link href="assets/css/bootstrap.min.css" id="bootstrap-style" rel="stylesheet" type="text/css" />
    <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap-select@1.13.14/dist/css/bootstrap-select.min.css">
    <link href="assets/css/icons.min.css" rel="stylesheet" type="text/css" />
    <link rel="stylesheet" href="assets/libs/owl.carousel/assets/owl.carousel.min.css">
    <link rel="stylesheet" href="assets/libs/owl.carousel/assets/owl.theme.default.min.css">
    <link href="assets/css/app.min.css" id="app-style" rel="stylesheet" type="text/css" />
    <link href="assets/css/custom.css" id="app-style" rel="stylesheet" type="text/css" />
  </head>

  <body @contextmenu.prevent data-sidebar="dark">
  <div id="layout-wrapper">
    <NavigationBar/>

    <div class="content-minimize">
      <div class="page-content">
        <div class="container-fluid">
          <!-- Page Header -->
          <div class="row">
            <div class="col-12">
              <div class="page-header-box mb-4">
                <h4 class="page-header-title">COMMITTEE REVIEW</h4>
                <p class="page-header-description">Review and approve inspected licence applications</p>
              </div>
            </div>
          </div>

          <ToolBarLiquor/>

          <!-- Statistics Cards -->
          <div class="row mb-4">
            <div class="col-xl-3 col-md-6 mb-3 mb-xl-0">
              <div class="card stat-card border-0 shadow-sm h-100">
                <div class="card-body">
                  <div class="d-flex align-items-center">
                    <div class="stat-icon-wrapper bg-warning-subtle rounded-circle me-3">
                      <i class="bx bx-clipboard text-warning"></i>
                    </div>
                    <div class="flex-grow-1">
                      <p class="text-muted mb-1 small text-uppercase fw-semibold">Pending Review</p>
                      <div class="d-flex align-items-baseline">
                        <h3 class="mb-0 fw-bold">{{ stats.totalApplications }}</h3>
                        <span class="badge bg-warning-subtle text-warning ms-2 small">Awaiting</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="card-footer bg-transparent border-0 pt-0">
                  <div class="progress" style="height: 4px;">
                    <div class="progress-bar bg-warning" style="width: 100%"></div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-xl-3 col-md-6 mb-3 mb-xl-0">
              <div class="card stat-card border-0 shadow-sm h-100">
                <div class="card-body">
                  <div class="d-flex align-items-center">
                    <div class="stat-icon-wrapper bg-success-subtle rounded-circle me-3">
                      <i class="bx bx-check-double text-success"></i>
                    </div>
                    <div class="flex-grow-1">
                      <p class="text-muted mb-1 small text-uppercase fw-semibold">Fully Paid</p>
                      <div class="d-flex align-items-baseline">
                        <h3 class="mb-0 fw-bold text-success">{{ stats.paidCount }}</h3>
                        <span class="text-muted ms-2 small">ready for review</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="card-footer bg-transparent border-0 pt-0">
                  <div class="progress" style="height: 4px;">
                    <div class="progress-bar bg-success" :style="{width: getProgressWidth('paid')}"></div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-xl-3 col-md-6 mb-3 mb-xl-0">
              <div class="card stat-card border-0 shadow-sm h-100">
                <div class="card-body">
                  <div class="d-flex align-items-center">
                    <div class="stat-icon-wrapper bg-info-subtle rounded-circle me-3">
                      <i class="bx bx-time-five text-info"></i>
                    </div>
                    <div class="flex-grow-1">
                      <p class="text-muted mb-1 small text-uppercase fw-semibold">Pending Payment</p>
                      <div class="d-flex align-items-baseline">
                        <h3 class="mb-0 fw-bold text-info">{{ stats.pendingCount }}</h3>
                        <span class="text-muted ms-2 small">with balance</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="card-footer bg-transparent border-0 pt-0">
                  <div class="progress" style="height: 4px;">
                    <div class="progress-bar bg-info" :style="{width: getProgressWidth('pending')}"></div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-xl-3 col-md-6">
              <div class="card stat-card border-0 shadow-sm h-100 bg-gradient-review text-white">
                <div class="card-body">
                  <div class="d-flex align-items-center">
                    <div class="stat-icon-wrapper bg-white bg-opacity-25 rounded-circle me-3">
                      <i class="bx bx-wallet text-white"></i>
                    </div>
                    <div class="flex-grow-1">
                      <p class="text-white-50 mb-1 small text-uppercase fw-semibold">Total Value</p>
                      <div class="d-flex align-items-baseline">
                        <h3 class="mb-0 fw-bold text-white">{{ formatCurrency(stats.totalInvoiced) }}</h3>
                      </div>
                      <small class="text-white-50">Paid: {{ formatCurrency(stats.totalPaid) }}</small>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Main Content Card -->
          <div class="row">
            <div class="col-12">
              <div class="card border-0 shadow-sm">
                <!-- Card Header -->
                <div class="card-header bg-white py-3 border-bottom">
                  <div class="row align-items-center g-3">
                    <div class="col-lg-4 col-md-6">
                      <div class="d-flex align-items-center">
                        <div class="header-icon me-3">
                          <i class="bx bx-clipboard"></i>
                        </div>
                        <div>
                          <h5 class="card-title mb-0 fw-semibold">Pending Review</h5>
                          <small class="text-muted">{{ totalItems }} applications awaiting committee review</small>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-8 col-md-6">
                      <div class="d-flex flex-wrap justify-content-lg-end gap-2">
                        <!-- Search -->
                        <div class="search-box">
                          <i class="bx bx-search search-icon"></i>
                          <input v-model="search" type="text" class="form-control"
                                 placeholder="Search invoice, business...">
                        </div>
                        <!-- Date Range -->
                        <div class="d-flex align-items-center gap-2">
                          <input v-model="dateFrom" type="date" class="form-control form-control-sm date-input">
                          <span class="text-muted small">to</span>
                          <input v-model="dateTo" type="date" class="form-control form-control-sm date-input">
                        </div>
                        <!-- Actions -->
                        <button @click="downloadApplications()" class="btn btn-outline-primary btn-sm">
                          <i class="bx bx-download"></i> {{ download }}
                        </button>
                        <button class="btn btn-soft-secondary btn-sm" type="button"
                                data-bs-toggle="collapse" data-bs-target="#filterSection">
                          <i class="bx bx-filter-alt"></i> Filters
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Collapsible Filters -->
                <div class="collapse" id="filterSection">
                  <div class="card-body bg-light border-bottom py-3">
                    <div class="row g-3">
                      <div class="col-md-3">
                        <label class="form-label small fw-semibold text-muted">Business Category</label>
                        <select @change="getTradeSubCategory($event)" class="form-select form-select-sm">
                          <option value="">All Categories</option>
                          <option :key="index" :value="item.incomeTypeId" v-for="(item, index) in tradeCategories">
                            {{ item.incomeTypeDescription }}
                          </option>
                        </select>
                      </div>
                      <div class="col-md-3">
                        <label class="form-label small fw-semibold text-muted">Sub Category</label>
                        <select @change="selectedTradeSubCategory($event)" class="form-select form-select-sm">
                          <option value="">All Sub Categories</option>
                          <option :key="index" :value="JSON.stringify(item)" v-for="(item, index) in tradeSubCategories">
                            {{ item.feeDescription }}
                          </option>
                        </select>
                      </div>
                      <div class="col-md-3">
                        <label class="form-label small fw-semibold text-muted">Sub County</label>
                        <select @change="selectedSubCounty($event)" class="form-select form-select-sm">
                          <option value="">All Sub Counties</option>
                          <option :key="index" :value="JSON.stringify(item)" v-for="(item, index) in subCounties">
                            {{ item.subCountyName }}
                          </option>
                        </select>
                      </div>
                      <div class="col-md-3">
                        <label class="form-label small fw-semibold text-muted">Ward</label>
                        <select @change="selectedWard($event)" class="form-select form-select-sm">
                          <option value="">All Wards</option>
                          <option :key="index" :value="JSON.stringify(item)" v-for="(item, index) in wards">
                            {{ item.wardName }}
                          </option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Table -->
                <div class="table-responsive">
                  <table class="table table-hover align-middle mb-0">
                    <thead class="bg-light">
                    <tr>
                      <th class="border-0 text-uppercase small fw-bold text-muted py-3">#</th>
                      <th class="border-0 text-uppercase small fw-bold text-muted py-3">Invoice No.</th>
                      <th class="border-0 text-uppercase small fw-bold text-muted py-3">Business</th>
                      <th class="border-0 text-uppercase small fw-bold text-muted py-3">Applicant</th>
                      <th class="border-0 text-uppercase small fw-bold text-muted py-3">Licence Category</th>
                      <th class="border-0 text-uppercase small fw-bold text-muted py-3">Location</th>
                      <th class="border-0 text-uppercase small fw-bold text-muted py-3">Inspected</th>
                      <th class="border-0 text-uppercase small fw-bold text-muted py-3 text-center">Status</th>
                      <th class="border-0 text-uppercase small fw-bold text-muted py-3 text-end">Amount</th>
                      <th class="border-0 text-uppercase small fw-bold text-muted py-3 text-center">Actions</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(item, index) in applications" :key="index" class="border-bottom">
                      <td class="py-3">
                        <span class="text-muted small">{{ ((currentPage - 1) * pageSize) + index + 1 }}</span>
                      </td>
                      <td class="py-3">
                        <a href="javascript: void(0);" class="fw-semibold text-primary text-decoration-none">
                          {{ item.billNo }}
                        </a>
                      </td>
                      <td class="py-3">
                        <div class="d-flex align-items-center">
                          <div class="avatar-sm me-2">
                              <span class="avatar-title rounded-circle bg-warning-subtle text-warning fw-bold">
                                {{ getInitials(item.businessName) }}
                              </span>
                          </div>
                          <span class="text-truncate d-inline-block" style="max-width: 130px;" :title="item.businessName">
                              {{ item.businessName || '-' }}
                            </span>
                        </div>
                      </td>
                      <td class="py-3">
                        <div>
                          <div class="fw-medium text-truncate" style="max-width: 120px;">{{ item.applicant || '-' }}</div>
                          <small class="text-muted">{{ item.phoneNumber || '-' }}</small>
                        </div>
                      </td>
                      <td class="py-3">
                        <div>
                          <span class="badge bg-light text-dark fw-normal">{{ item.licenceCategory || item.businessSubCategory || '-' }}</span>
                          <div class="small text-muted mt-1" v-if="item.licenceDuration">
                            <i class="bx bx-time-five"></i> {{ item.licenceDuration }}
                          </div>
                        </div>
                      </td>
                      <td class="py-3">
                        <div>
                          <div class="small fw-medium">{{ item.subCountyName || '-' }}</div>
                          <small class="text-muted">{{ item.wardName || '-' }}</small>
                        </div>
                      </td>
                      <td class="py-3">
                        <span class="text-muted small">{{ formatDate(item.dateInspected) }}</span>
                      </td>
                      <td class="py-3 text-center">
                          <span class="badge bg-warning text-dark rounded-pill px-3">
                            {{ item.status }}
                          </span>
                      </td>
                      <td class="py-3 text-end">
                        <div>
                          <div class="fw-bold">{{ formatCurrency(item.billTotal) }}</div>
                          <small :class="parseFloat(item.billBalance) > 0 ? 'text-danger' : 'text-success'">
                            Bal: {{ formatCurrency(item.billBalance) }}
                          </small>
                        </div>
                      </td>
                      <td class="py-3 text-center">
                        <div class="d-flex gap-1 justify-content-center">
                          <button @click="applicationDetails(item)" type="button"
                                  class="btn btn-sm btn-soft-warning rounded-circle"
                                  data-bs-toggle="modal" data-bs-target=".receipting-modal"
                                  title="Review Application">
                            <i class="bx bx-edit-alt"></i>
                          </button>
                          <button @click="printViewBill(item)" type="button"
                                  class="btn btn-sm btn-soft-success rounded-circle"
                                  title="Print Invoice">
                            <i class="bx bx-printer"></i>
                          </button>
                        </div>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>

                <!-- Loading State -->
                <div class="text-center py-5" v-if="loading">
                  <div class="spinner-border text-primary" role="status"></div>
                  <p class="mt-2 text-muted mb-0">Loading applications...</p>
                </div>

                <!-- Empty State -->
                <div class="text-center py-5" v-if="applications.length < 1 && !loading">
                  <div class="empty-icon mb-3">
                    <i class="bx bx-clipboard"></i>
                  </div>
                  <h5 class="text-muted">No Applications Pending Review</h5>
                  <p class="text-muted small mb-3">All inspected applications have been reviewed</p>
                  <button @click="resetFilters()" class="btn btn-primary btn-sm">
                    <i class="bx bx-refresh me-1"></i> Reset Filters
                  </button>
                </div>

                <!-- Footer with Pagination -->
                <div class="card-footer bg-white border-top py-3" v-if="applications.length > 0">
                  <div class="row align-items-center">
                    <div class="col-md-5">
                      <p class="text-muted mb-0 small">
                        Showing <strong>{{ ((currentPage - 1) * pageSize) + 1 }}</strong> to
                        <strong>{{ Math.min(currentPage * pageSize, totalItems) }}</strong> of
                        <strong>{{ totalItems }}</strong> entries
                      </p>
                    </div>
                    <div class="col-md-7">
                      <div class="d-flex align-items-center justify-content-md-end gap-3">
                        <select class="form-select form-select-sm" style="width: 80px;" v-model="pageSize">
                          <option value="10">10</option>
                          <option value="25">25</option>
                          <option value="50">50</option>
                          <option value="100">100</option>
                        </select>
                        <nav>
                          <ul class="pagination pagination-sm mb-0">
                            <li :class="{ disabled: currentPage === 1 }" class="page-item">
                              <a @click.prevent="prevPage" class="page-link" href="javascript: void(0);">
                                <i class="bx bx-chevron-left"></i>
                              </a>
                            </li>
                            <li v-for="page in visiblePages" :key="page"
                                :class="{ active: currentPage === page, disabled: page === '...' }" class="page-item">
                              <a @click.prevent="page !== '...' && goToPage(page)" class="page-link" href="javascript: void(0);">{{ page }}</a>
                            </li>
                            <li :class="{ disabled: currentPage === totalPages }" class="page-item">
                              <a @click.prevent="nextPage" class="page-link" href="javascript: void(0);">
                                <i class="bx bx-chevron-right"></i>
                              </a>
                            </li>
                          </ul>
                        </nav>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Review Modal -->
      <ReviewModal
          ref="reviewModal"
          :application="application"
          :applicationStatuses="applicationStatuses"
          @print-bill="handlePrintBill"
          @submit-review="handleSubmitReview"
      />

      <footer class="footer">
        <div class="container-fluid">
          <div class="row">
            <div class="col-sm-6"></div>
            <div class="col-sm-6">
              <div class="text-sm-end d-sm-block">County Billing System</div>
            </div>
          </div>
        </div>
      </footer>
    </div>
  </div>
  </body>
</template>

<script>
/* eslint-disable */
import { execute, biller, liquor, authUrl, executeDownload } from "@/api";
import NavigationBar from "@/components/Navigation.vue";
import ToolBarLiquor from "@/components/liquor/ToolBarLiquor.vue";
import ReviewModal from "@/components/liquor/modal/ReviewModal.vue";
import moment from "moment/moment";

export default {
  name: "CertAlcoholPendingReview",
  components: { ToolBarLiquor, NavigationBar, ReviewModal },
  data() {
    return {
      download: 'Download',
      currentPage: 1,
      totalPages: 0,
      pageSize: 10,
      totalItems: 0,
      search: '',
      dateFrom: '',
      dateTo: '',
      loading: false,
      message: null,
      applications: [],
      application: {},
      applicationStatuses: [],
      tradeCategories: [],
      tradeSubCategories: [],
      subCounties: [],
      wards: [],
      billDetails: { billNo: '' },
      stats: {
        totalApplications: 0,
        paidCount: 0,
        pendingCount: 0,
        totalInvoiced: 0,
        totalPaid: 0,
        totalBalance: 0
      }
    }
  },
  computed: {
    visiblePages() {
      const pages = [];
      const total = this.totalPages || 1;
      const current = this.currentPage;

      if (total <= 5) {
        for (let i = 1; i <= total; i++) pages.push(i);
      } else {
        if (current <= 3) {
          pages.push(1, 2, 3, 4, '...', total);
        } else if (current >= total - 2) {
          pages.push(1, '...', total - 3, total - 2, total - 1, total);
        } else {
          pages.push(1, '...', current - 1, current, current + 1, '...', total);
        }
      }
      return pages;
    }
  },
  mounted() {
    this.dateFrom = moment().subtract(1, 'year').format('YYYY-MM-DD');
    this.dateTo = moment().format('YYYY-MM-DD');
    this.init();
  },
  watch: {
    search() {
      this.currentPage = 1;
      this.getApplications(this.search);
    },
    pageSize() {
      this.currentPage = 1;
      this.getApplications("");
    },
    dateFrom() {
      if (this.dateFrom && this.dateTo) {
        this.getApplications("");
        this.getStats();
      }
    },
    dateTo() {
      if (this.dateFrom && this.dateTo) {
        this.getApplications("");
        this.getStats();
      }
    }
  },
  methods: {
    init() {
      this.menuAccess();
      this.getTradeCategory();
      this.getSubCounties();
      this.getApplications("");
      this.getStats();
    },

    menuAccess() {
      const data = new FormData();
      data.append("function", "menuAccess");
      data.append("menu", "Cert Alcohol Pending Review");
      data.append("sessionNames", sessionStorage.getItem("sessionNames"));
      data.append("sessionIdNo", sessionStorage.getItem("sessionIdNo"));
      execute(data, biller);
    },

    resetFilters() {
      this.search = '';
      this.dateFrom = moment().subtract(1, 'year').format('YYYY-MM-DD');
      this.dateTo = moment().format('YYYY-MM-DD');
      this.currentPage = 1;
      this.getApplications("");
    },

    getStats() {
      const data = new FormData();
      data.append("function", "getApplicationStats");
      data.append("statusID", "3");
      data.append("dateFrom", this.dateFrom);
      data.append("dateTo", this.dateTo);
      execute(data, liquor)
          .then((res) => {
            if (res.data.success && res.data.data.stats) {
              this.stats = res.data.data.stats;
            }
          })
          .catch(() => {});
    },

    getProgressWidth(type) {
      const total = this.stats.totalApplications || 1;
      if (type === 'paid') return ((this.stats.paidCount / total) * 100) + '%';
      if (type === 'pending') return ((this.stats.pendingCount / total) * 100) + '%';
      return '0%';
    },

    getInitials(name) {
      if (!name) return '?';
      return name.split(' ').map(n => n[0]).join('').substring(0, 2).toUpperCase();
    },

    formatDate(dateString) {
      if (!dateString || dateString === '-') return '-';
      return moment(dateString).format('DD MMM YYYY');
    },

    formatCurrency(amount) {
      if (!amount || isNaN(amount)) return 'KES 0';
      return 'KES ' + parseFloat(amount).toLocaleString('en-KE');
    },

    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
        this.getApplications("");
      }
    },

    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
        this.getApplications("");
      }
    },

    goToPage(page) {
      if (page >= 1 && page <= this.totalPages) {
        this.currentPage = page;
        this.getApplications("");
      }
    },

    getSubCounties() {
      const data = new FormData();
      data.append("function", "getSubCounties");
      execute(data, authUrl).then((res) => {
        if (res.data.success) this.subCounties = res.data.data.subCounties;
      });
    },

    getWards(subCountyID) {
      const data = new FormData();
      data.append("function", "getWards");
      data.append("subCountyID", subCountyID);
      execute(data, authUrl).then((res) => {
        if (res.data.success) this.wards = res.data.data.wards;
      });
    },

    getTradeCategory() {
      const data = new FormData();
      data.append("function", "getIncomeTypes");
      data.append("incomeTypePrefix", "SBP");
      execute(data, biller).then((res) => {
        if (res.data.success) this.tradeCategories = res.data.data.incomeTypes;
      });
    },

    getTradeSubCategory(event) {
      this.getApplications(event.target.value);
      const data = new FormData();
      data.append("function", "getFeesAndCharges");
      data.append("incomeTypeId", event.target.value);
      execute(data, biller).then((res) => {
        if (res.data.success) this.tradeSubCategories = res.data.data.feesAndCharges;
      });
    },

    selectedTradeSubCategory(event) {
      if (!event.target.value) return;
      this.getApplications(JSON.parse(event.target.value).feeId);
    },

    selectedSubCounty(event) {
      if (!event.target.value) return;
      const data = JSON.parse(event.target.value);
      this.getWards(data.subCountyID);
      this.getApplications(data.subCountyName);
    },

    selectedWard(event) {
      if (!event.target.value) return;
      this.getApplications(JSON.parse(event.target.value).wardName);
    },

    getApplications(search) {
      this.loading = true;
      this.applications = [];
      const data = new FormData();
      data.append("function", "getApplications");
      data.append("statusID", "3");
      data.append("search", search);
      data.append("printable", "false");
      data.append("dateFrom", this.dateFrom);
      data.append("dateTo", this.dateTo);
      data.append("page", this.currentPage);
      data.append("rows_per_page", this.pageSize);
      execute(data, liquor).then((res) => {
        this.loading = false;
        if (res.data.success) {
          this.applications = res.data.data.applications || [];
          this.totalItems = res.data.data.totalItems?.count || this.applications.length;
          this.totalPages = Math.ceil(this.totalItems / this.pageSize) || 1;
          this.calculateLocalStats();
        }
      }).catch(() => { this.loading = false; });
    },

    calculateLocalStats() {
      let totalInvoiced = 0;
      let totalPaid = 0;
      let paidCount = 0;

      this.applications.forEach(app => {
        totalInvoiced += parseFloat(app.billTotal) || 0;
        totalPaid += parseFloat(app.receiptAmount) || 0;
        if (parseFloat(app.billBalance) === 0) paidCount++;
      });

      this.stats.totalApplications = this.totalItems;
      this.stats.paidCount = paidCount;
      this.stats.pendingCount = this.applications.length - paidCount;
      this.stats.totalInvoiced = totalInvoiced;
      this.stats.totalPaid = totalPaid;
      this.stats.totalBalance = totalInvoiced - totalPaid;
    },

    getApplicationStatus() {
      const data = new FormData();
      data.append("function", "getApplicationStatus");
      data.append("billNo", this.application.billNo);
      execute(data, liquor).then((res) => {
        if (res.data.success) {
          const statuses = res.data.data.applicationStatuses;
          const invoicingStatus = statuses.find(s => s.status === "Invoicing");
          const otherStatuses = statuses.filter(s => s.status !== "Invoicing");
          this.applicationStatuses = invoicingStatus ? [invoicingStatus, ...otherStatuses] : statuses;
        }
      });
    },

    downloadApplications() {
      this.download = "Wait...";
      const data = new FormData();
      data.append("function", "downloadApplications");
      data.append("statusID", "3");
      data.append("dateFrom", this.dateFrom);
      data.append("dateTo", this.dateTo);
      executeDownload(data, liquor).then(response => {
        this.download = "Download";
        const link = document.createElement('a');
        link.href = URL.createObjectURL(response.data);
        link.download = `pending_review_${this.dateFrom}_to_${this.dateTo}.csv`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      });
    },

    applicationDetails(item) {
      this.application = { ...item };
      this.billDetails.billNo = item.billNo;
      this.getApplicationStatus();
    },

    printViewBill(item) {
      this.billDetails.billNo = item.billNo;
      this.printBill();
    },

    handlePrintBill(billNo) {
      this.billDetails.billNo = billNo;
      this.printBill();
    },

    printBill() {
      localStorage['params'] = JSON.stringify({ billNo: this.billDetails.billNo });
      window.open(this.$router.resolve({ name: 'bill' }).href, '_blank');
    },

    handleSubmitReview(reviewData) {
      const data = new FormData();
      data.append("function", "approveDeclineApplication");
      data.append("billNo", reviewData.billNo);
      data.append("createdBy", sessionStorage.getItem("sessionNames"));
      data.append("idNo", sessionStorage.getItem("sessionIdNo"));
      data.append("businessName", reviewData.businessName);
      data.append("approveRemarks", reviewData.approveRemarks);
      data.append("declinedReason", reviewData.declinedReason);
      data.append("minutesNumber", reviewData.minutesNumber);
      data.append("reviewStatus", reviewData.reviewStatus);

      if (reviewData.selectedFile) {
        data.append("fileToUpload", reviewData.selectedFile);
      }

      execute(data, liquor).then((res) => {
        if (res.data.success) {
          if (reviewData.reviewStatus === 'Approve') {
            this.generateBill(reviewData.feesAndChargeItems);
          } else {
            this.$refs.reviewModal.stopProcessing();
            $('.receipting-modal').modal('hide');
            this.getApplications("");
            alert('Application declined successfully');
          }
        } else {
          this.$refs.reviewModal.stopProcessing();
          alert(res.data.message);
        }
      }).catch((e) => {
        this.$refs.reviewModal.stopProcessing();
        alert(e.message);
      });
    },

    generateBill(feesAndChargeItems) {
      let items = typeof feesAndChargeItems === 'string'
          ? JSON.parse(feesAndChargeItems)
          : feesAndChargeItems;

      items = items.map(item => ({
        ...item,
        customerName: this.application.businessName,
        customerPhoneNumber: this.application.phoneNumber
      }));

      const data = new FormData();
      data.append("function", "generateBill3");
      data.append("printable", "true");
      data.append("payNow", "false");
      data.append("customerPhoneNumber", this.application.phoneNumber || '');
      data.append("email", this.application.email || '');
      data.append("billItem", JSON.stringify(items));

      execute(data, biller).then((res) => {
        if (res.data.success) {
          this.billDetails = res.data.data.bill.billDetails;
          this.updateApplicationInvoice();
        } else {
          this.$refs.reviewModal.stopProcessing();
          alert(res.data.message);
        }
      }).catch((e) => {
        this.$refs.reviewModal.stopProcessing();
        alert(e.message);
      });
    },

    updateApplicationInvoice() {
      const data = new FormData();
      data.append("function", "updateApplicationInvoice");
      data.append("licenceBillNo", this.billDetails.billNo);
      data.append("billNo", this.application.billNo);
      execute(data, liquor).then((res) => {
        this.$refs.reviewModal.stopProcessing();
        if (res.data.success) {
          $('.receipting-modal').modal('hide');
          this.getApplications("");
          alert('Application approved and invoice generated successfully');
        } else {
          alert(res.data.message);
        }
      }).catch((e) => {
        this.$refs.reviewModal.stopProcessing();
        alert(e.message);
      });
    }
  }
}
</script>

<style scoped>
/* Page Header */
.page-header-box {
  background: #f8f9fa;
  padding: 20px 24px;
  border-radius: 0;
  border-bottom: 3px solid #1a2b4a;
}

.page-header-title {
  font-size: 16px;
  font-weight: 700;
  color: #1a2b4a;
  margin-bottom: 4px;
  letter-spacing: 0.5px;
}

.page-header-description {
  font-size: 13px;
  color: #6c757d;
  margin-bottom: 0;
}

/* Gradient Background */
.bg-gradient-review {
  background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%) !important;
}

/* Stat Cards */
.stat-card {
  border-radius: 12px;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.stat-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 10px 30px rgba(0,0,0,0.12) !important;
}

.stat-icon-wrapper {
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
}

.bg-primary-subtle { background-color: rgba(102, 126, 234, 0.15); }
.bg-warning-subtle { background-color: rgba(255, 193, 7, 0.15); }
.bg-success-subtle { background-color: rgba(25, 135, 84, 0.15); }
.bg-info-subtle { background-color: rgba(13, 202, 240, 0.15); }

/* Header Icon */
.header-icon {
  width: 45px;
  height: 45px;
  background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 1.25rem;
}

/* Search Box */
.search-box {
  position: relative;
  width: 240px;
}

.search-box .search-icon {
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: #adb5bd;
}

.search-box .form-control {
  padding-left: 38px;
  border-radius: 8px;
  border: 1px solid #e9ecef;
  font-size: 0.875rem;
  height: 38px;
}

.search-box .form-control:focus {
  border-color: #f093fb;
  box-shadow: 0 0 0 3px rgba(240, 147, 251, 0.15);
}

/* Date Input */
.date-input {
  width: 130px;
  border-radius: 6px;
  font-size: 0.8125rem;
}

/* Avatar */
.avatar-sm {
  width: 36px;
  height: 36px;
}

.avatar-title {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.8rem;
}

/* Buttons */
.btn-soft-warning {
  background-color: rgba(255, 193, 7, 0.15);
  color: #997404;
  border: none;
}

.btn-soft-warning:hover {
  background-color: rgba(255, 193, 7, 0.25);
  color: #664d03;
}

.btn-soft-success {
  background-color: rgba(25, 135, 84, 0.1);
  color: #198754;
  border: none;
}

.btn-soft-success:hover {
  background-color: rgba(25, 135, 84, 0.2);
  color: #146c43;
}

.btn-soft-secondary {
  background-color: #f1f3f5;
  color: #495057;
  border: none;
}

.btn-soft-secondary:hover {
  background-color: #e9ecef;
}

.rounded-circle.btn {
  width: 32px;
  height: 32px;
  padding: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

/* Empty State */
.empty-icon {
  width: 80px;
  height: 80px;
  background: #f8f9fa;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  font-size: 2.5rem;
  color: #adb5bd;
}

/* Pagination */
.pagination .page-link {
  border: none;
  padding: 0.4rem 0.75rem;
  color: #6c757d;
  border-radius: 6px;
  margin: 0 2px;
}

.pagination .page-item.active .page-link {
  background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);
  color: white;
}

/* Table */
table tbody tr {
  transition: background-color 0.15s ease;
}

table tbody tr:hover {
  background-color: #fff9fc;
}

/* Responsive */
@media (max-width: 992px) {
  .search-box { width: 100%; }
  .date-input { width: 120px; }
}
</style>